import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The day I crashed production 4 times",
  "description": "",
  "published": "2019-07-19T00:00:00.000Z",
  "redirect_from": ["/blog/the-day-i-crashed-production-4-times/swizec/9159"],
  "categories": "Back End, Technical, Uncategorized",
  "hero": "./img/4cGsqLq.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wednesday was a fun day for me my friend. A system I'd been working on for months went live and everything died. 😅`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/9d194742bb5e26ba3af0de90c7911f4d/3a1b1/4cGsqLq.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "26.905829596412556%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'108\\'%20viewBox=\\'0%200%20400%20108\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M9%2010v8l1%206h33V10L26%209%209%2010m1%2025l-1%208%201%206h33V35l-16-1-17%201M9%2061v7l1%206h33V60H27L9%2061m0%2024v8l1%206h33V85l-17-1-17%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/9d194742bb5e26ba3af0de90c7911f4d/ca0a1/4cGsqLq.webp 223w", "/static/9d194742bb5e26ba3af0de90c7911f4d/75680/4cGsqLq.webp 445w", "/static/9d194742bb5e26ba3af0de90c7911f4d/8d1ba/4cGsqLq.webp 890w", "/static/9d194742bb5e26ba3af0de90c7911f4d/3838e/4cGsqLq.webp 1335w", "/static/9d194742bb5e26ba3af0de90c7911f4d/0ae27/4cGsqLq.webp 1686w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/9d194742bb5e26ba3af0de90c7911f4d/e92b6/4cGsqLq.png 223w", "/static/9d194742bb5e26ba3af0de90c7911f4d/e66bf/4cGsqLq.png 445w", "/static/9d194742bb5e26ba3af0de90c7911f4d/4ef49/4cGsqLq.png 890w", "/static/9d194742bb5e26ba3af0de90c7911f4d/4e814/4cGsqLq.png 1335w", "/static/9d194742bb5e26ba3af0de90c7911f4d/3a1b1/4cGsqLq.png 1686w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/9d194742bb5e26ba3af0de90c7911f4d/4ef49/4cGsqLq.png",
              "alt": "4cGsqLq",
              "title": "4cGsqLq",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Deploy. HOT PATCH. Patch. Fix. phew`}</p>
    <p>{`You might remember reading about this system in December when I wrote about `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/logging-events-postgres-rails-heroku-javascript/swizec/8825"
      }}>{`Logging 1,721,410 events per day with Postgres, Rails, Heroku, and a bit of JavaScript`}</a>{`. Yes I know what you're going to say ...`}</p>
    <blockquote>
      <p parentName="blockquote">{`Yo, Swiz, dunno if you've heard, logging is a solved problem bro. It don't have to be this hard. Just write to a text file and parse it later.`}</p>
    </blockquote>
    <p>{`Think of this more as telemetry for an entire product, business, and everything in between. We need logs from various clients (web and mobile), we need to tie those logs back to real users and devices and business tests, and we need every department in the company to use these for analytics to drive business decisions.`}</p>
    <p>{`Yeah it touches everything.`}</p>
    <p>{`So of course I crashed it.`}</p>
    <p>{`Not only did I crash it. I brought down `}<em parentName="p">{`everything`}</em>{`. Every single API that we've got was errorring out. For a whole hour.`}</p>
    <p><img parentName="p" {...{
        "src": "/bb0d75b37566530d4841e86bf30b89e5/media-fxZ7cC3zYIVXi-giphy.gif",
        "alt": "everything giphy"
      }}></img></p>
    <h2 {...{
      "id": "so-what-happened"
    }}>{`So what happened?`}</h2>
    <p>{`The backstory is that we're moving the whole system to AWS Lambda as a ... microservice. A nanoservice? A bunch of FaaS? What do you call a gaggle of lambda functions that work together as a system?`}</p>
    <p>{`So I've been working on that for a few months and on Wednesday it was time to unleash Phase 1 upon the world.`}</p>
    <p>{`Pipe logs to AWS and see what happens. Disable the lambdas that push to Datadog and Mixpanel.`}</p>
    <p>{`Goal was to run both the old and the new system in parallel and work out the kinks. I was certain `}<em parentName="p">{`something`}</em>{` was going to go wrong. And we can't have an outage of a business critical system now can we?`}</p>
    <p>{`Instead we had an outage of everything. 😇`}</p>
    <p>{`Our API requests create metrics, you see. Something like `}<inlineCode parentName="p">{`backend.request.success`}</inlineCode>{` with a bit of metadata about the request, the user, stuff like that.`}</p>
    <p>{`Most metrics go through a function that adds more info. A sort of catch all for meta data when it makes sense.`}</p>
    <p>{`But `}<em parentName="p">{`those`}</em>{` backend metrics do not. There's too many of them and the metadataing is too slow. Hella SQL queries.`}</p>
    <p>{`While refactoring I moved a piece of code from the normal flow to the metadata flow.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=ruby&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=log%5B%22created_day%22%5D%20%3D%20Date.today"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "350px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.36322869955157%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'214\\'%20viewBox=\\'0%200%20400%20214\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M39%2057l-2%202v49l1%2050c2%203%203%203%20163%203%20159%200%20160%200%20162-3l1-50V59l-2-2c-4-3-319-3-323%200m40%2018c-4%204-1%2011%205%2011%203%200%207-4%207-6%200-6-8-9-12-5m23%201c-3%203-3%205%201%208%204%204%2010%201%2010-5%200-5-7-8-11-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/87e702a56b7535d38078f6a6084a3e78/ca0a1/techletter.app-screenshot-1563553812054.webp 223w", "/static/87e702a56b7535d38078f6a6084a3e78/a3432/techletter.app-screenshot-1563553812054.webp 350w"],
                "sizes": "(max-width: 350px) 100vw, 350px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/87e702a56b7535d38078f6a6084a3e78/e92b6/techletter.app-screenshot-1563553812054.png 223w", "/static/87e702a56b7535d38078f6a6084a3e78/13ae7/techletter.app-screenshot-1563553812054.png 350w"],
                "sizes": "(max-width: 350px) 100vw, 350px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/87e702a56b7535d38078f6a6084a3e78/13ae7/techletter.app-screenshot-1563553812054.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Moved it a few lines down.`}</p>
    <p>{`Innocuous change right? What could possibly go wrong?`}</p>
    <p><img parentName="p" {...{
        "src": "/15a77169d63e1b08bed8ab74c6804547/media-11DFuwckOK9mdG-giphy.gif",
        "alt": "ha! giphy"
      }}></img></p>
    <p>{`In production we use that field to build `}<a parentName="p" {...{
        "href": "https://www.postgresql.org/docs/10/ddl-partitioning.html"
      }}>{`table partitions`}</a>{`. It's a way to speed up Postgres tables by effectively splitting them into smaller tables. You need that when you're writing millions of rows per day.`}</p>
    <p>{`Partitioning is a lot like the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Shard_(database_architecture)"
      }}>{`sharding`}</a>{` concept from NoSQL.`}</p>
    <p>{`You can't build partitions on `}<inlineCode parentName="p">{`null`}</inlineCode>{` fields.`}</p>
    <p>{`That throws a database error.`}</p>
    <p>{`That database error says `}<em parentName="p">{`"Yo you can't write this log"`}</em></p>
    <p>{`That error throws an exception`}</p>
    <p>{`That exception bubbles up`}</p>
    <p>{`Your API request fails`}</p>
    <p><em parentName="p">{`Every`}</em>{` API request fails`}</p>
    <p>{`Your service goes down. You have a big outage.`}</p>
    <p>{`You have to stop eating lunch and go fix that shit. Yeah don't run a big scary deploy and go eat lunch thinking all will be well. All will not be well.`}</p>
    <p><img parentName="p" {...{
        "src": "/193caff7696dd261ed4b4275404699d0/media-M2AmFHxMydFok-giphy.gif",
        "alt": "heh giphy"
      }}></img></p>
    <p>{`The hotpatch was easy. Move the code, deploy. Service restored.`}</p>
    <p>{`The proper fix included writing some tests. And we discovered another error thanks to `}<a parentName="p" {...{
        "href": "https://sentry.io/welcome/"
      }}>{`Sentry errors`}</a>{`.`}</p>
    <p>{`Fixing `}<em parentName="p">{`that`}</em>{` error caused another error because I'm dumb. But that error was in the background with no effect on the end users. Just meant that a queue was filling up with data and would eventually drain when we fix the bug.`}</p>
    <p>{`Those are the kind of errors you can take your sweet time to fix. 👌`}</p>
    <h2 {...{
      "id": "what-did-i-learn"
    }}>{`What did I learn?`}</h2>
    <p>{`A bunch of things!`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Our `}<a parentName="strong" {...{
            "href": "https://www.datadoghq.com/"
          }}>{`Datadog`}</a>{` alarms work great.`}</strong>{` We have a system of overlapping alarms that trigger even if parts of the system don't work. Hard to trigger a `}<em parentName="li">{`Too many errors`}</em>{` alarm if there's no events coming through right? But you can trigger a `}<em parentName="li">{`Too few API requests`}</em>{` alarm 😉`}</li>
      <li parentName="ol"><strong parentName="li">{`It's easy to ignore alarms that look like alarms you've ignored in the past`}</strong>{`. Sometimes our alarms freak out for no reason. When that happens we've learned to say `}<em parentName="li">{`"Eh it ain't so bad we'll fix it later"`}</em>{`. That lead us astray here because a super-very-critical alarm looked a lot like a not-quite-critical alarm.`}</li>
      <li parentName="ol"><strong parentName="li">{`Avoid refactors without test coverage`}</strong>{`. The root cause of my woes? Poor test coverage. Both automated test and manual QA test coverage. This is a critical system so of course we've got tests. I relied on those when refactoring. But I missed that coverage was poor so most of my code didn't even get tested. 🤦‍♂️`}</li>
      <li parentName="ol"><strong parentName="li">{`Consider using a typed language for critical stuff`}</strong>{`. Types are like automated unit tests with 100% coverage for many sorts of checks. They totally would have caught what I broke while refactoring. AND you are forced to write types all along so coverage is 100% if you avoid `}<inlineCode parentName="li">{`any`}</inlineCode>{`.`}</li>
      <li parentName="ol"><strong parentName="li">{`Decouple. Decouple. Decouple. Then decouple some more.`}</strong>{` Why was a failure in logging able to crash the system it was observing? No excuse. The move to AWS Lambda automatically solves the problem but damn. Past Swizec why you dumb?`}</li>
    </ol>
    <p>{`Lucky for me this was the only tight coupling in the system. That's why the other 3 errors weren't critical: Clients don't rely on logs succeeding. Backend processing doesn't rely on processing succeeding. Even the backend itself doesn't rely on any of that to work.`}</p>
    <p>{`It was just this one darn thing ...`}</p>
    <p>{`✌️`}</p>
    <p>{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      